import axiosInstance from '../../../../config/axiosInstance';
const  FormPermissionService = {
    
    async GetFormPermissions(redirectCallback,RoleID,ClientID) {
        try {           
            const response = await axiosInstance.get(`/Setup/GetAllFormPermissions?RoleID=${RoleID}&ClientID=${ClientID}`);
            const FormPermissionList=response.data[0];
            return FormPermissionList;
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async HasPerimssion(redirectCallback,RoleID, FormURL)
    {   
        const response = await axiosInstance.get(`/Setup/GetPermission?RoleID=${RoleID}&FormURL=${FormURL}`);
        const FormPermission=response.data[0][0];
        if(FormPermission.Forms==0)
        {
            window.location.href = '/Unauthorized';
            return;
        }
    }

};

export default FormPermissionService;